if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        function render_cart_products(data) {
          let cartContentHtml;
          if (data.item_count === 0) {
            // Render empty cart message
            if ($('.cart-empty').length === 0) {
            cartContentHtml = `
            <div class="cart-empty">
              <h3>Your cart is empty</h3>
              <a href="/collections/all" class="cartBtn cartBtnBox">Continue Shopping</a>
            </div>
          `;
          }}
          else {
            // Render cart content
              const keywords = [
              'VOICE CODE',
              'SPIRIT MOLECULE',
              'SUPER CALM',
              'INDIGO',
              'MIRACLE STRUCTURED WATER',
              'MIRACLE IQUBE',
              'TESLA IQUBE',
              'THE POCKET MIRACLE',
            ];
            
            cartContentHtml = `
              <div class="cart-content">
                <div class="cart-items">
                  ${data.items
                    .map((item, index) => {
                      let overrideTitle = "";
                      const waters = ['SPIRIT MOLECULE', 'SUPER CALM', 'INDIGO', 'MIRACLE'];
            
                      // Replicate the Liquid logic in JavaScript
                      for (const keyword of keywords) {
                        if (item.title.includes(keyword)) {
                          if (keyword === 'THE POCKET MIRACLE') {
                            overrideTitle = 'OM POCKET';
                          } else if (keyword === 'MIRACLE STRUCTURED WATER') {
                            overrideTitle = 'MIRACLE';
                          } else {
                            overrideTitle = keyword;
                          }
                          break;
                        }
                      }
                      //second filter Check against waters array
                            for (const water of waters) {
                                if (item.title.includes(water)) {

                                    // Additional logic: Append based on price
                                    if (item.price == 100.00) { // Assuming price is in cents
                                        overrideTitle += ' - 5 Bottles';
                                    } else {
                                        overrideTitle += ' - 1 Bottle';
                                    }
                                    break;
                                }
                            }
            
                      return `
                        <div class="MyCartBox">
                          ${
                            item.image
                              ? `<div class="menu-cart__product-image">
                                  <a href="${item.url}">
                                    <img width="300" height="300"
                                      src="${item.image}"
                                      alt="${item.title}" decoding="async">
                                  </a>
                                </div>`
                              : ''
                          }
                          <div class="CartContent">
                            <div class="menu-cart__product-name">
                              <a href="${item.url}">
                                ${overrideTitle || item.title}
                              </a>
                            </div>
                            <div class="menu-cart__product-price">
                              <span class="My__quantity">
                                <span class="product-quantity">${item.quantity} ×</span>
                                <span class="woocommerce-Price-amount amount">
                                  <bdi><span class="woocommerce-Price-currencySymbol">$</span>${(
                                    item.price / 100
                                  ).toFixed(2)}</bdi>
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="menu-cart__product-remove product-remove">
                            <a href="" line_number=${index + 1} class="remove_from_cart_button">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                <path fill="#69727d" fill-rule="evenodd" d="M11.782 4.032a.575.575 0 1 0-.813-.814L7.5 6.687L4.032 3.218a.575.575 0 0 0-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 0 0 .814.814L7.5 8.313l3.469 3.469a.575.575 0 0 0 .813-.814L8.313 7.5z" clip-rule="evenodd" />
                              </svg>
                            </a>
                          </div>
                        </div>
                      `;
                    })
                    .join('')}
                </div>
                <div class="cart-footer">
                  <div class="cart-total">
                    <span class="SubTotal">Subtotal:</span>
                    <span class="TtlPrice">$${(data.total_price / 100).toFixed(2)}</span>
                  </div>
                  <div class="cart-buttons">
                    <a href="/cart" class="cartBtn cartBtnText">View cart</a>
                    <a href="/checkout" class="cartBtn cartBtnBox">Checkout</a>
                  </div>
                </div>
              </div>
            `;

          }
          $('#sidebar-cart').append(cartContentHtml);
        }
        function remove_item_from_cart() {

          // Remove item from cart
          $(document).on('click', '.remove_from_cart_button', function (event) {
            event.preventDefault();
            const lineNumber = $(this).attr('line_number');
            const updates = {
              line: lineNumber,
              quantity: 0,
            };
            //calling ajax to update product quantity to 0
            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json', // Specify that the body is JSON
              },
              body: JSON.stringify(updates), // Convert the updates object to JSON string
            })
              .then(response => response.json())
              .then(data => {

                render_sidebar_cart();
              })
              .catch(error => console.error('Error:', error));

          });
        }
        function render_sidebar_cart() {
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
             if (data.item_count === 1) {
              // Remove cart empty text
              const emptyCartDiv = document.querySelector(".cart-empty");
              if (emptyCartDiv) {
                emptyCartDiv.remove();
              } else {
                $(".cart-count-bubble").children().eq(0).text(data.item_count);
                const emptyCartCont = document.querySelector(".cart-content");
                if (emptyCartCont) {
                  emptyCartCont.remove();
                }
              }
              
              // Render cart items
              render_cart_products(data);
            
              // Remove cart items
              console.log("Inside If: next remove cart call. item count before that ");
              console.log(data.item_count);
              remove_item_from_cart();
              console.log("Inside If: after remove cart call. item count now ");
              console.log(data.item_count);
            
              // Update or add cart bubble
              const cartIconBubble = document.getElementById("cart-icon-bubble");
              const cartCountBubble = document.querySelector(".cart-count-bubble"); // Use querySelector to check existence
              
              if (cartIconBubble && !cartCountBubble) { // Ensure this checks the absence of the bubble
                const cartBubble = document.createElement("div");
                cartBubble.className = "cart-count-bubble";
                cartBubble.innerHTML = `
                  <span aria-hidden="true">${data.item_count}</span>
                  <span class="visually-hidden">Cart has ${data.item_count} item</span>
                `;
                cartIconBubble.appendChild(cartBubble);
              } else if (cartCountBubble) {
                // If bubble exists, just update the count
                const countSpan = cartCountBubble.querySelector("span[aria-hidden='true']");
                if (countSpan) {
                  countSpan.textContent = data.item_count;
                }
              }
            }

              else {
                const emptyCartCont = document.querySelector(".cart-content");
                if (emptyCartCont) {
                  emptyCartCont.remove();
                }
                render_cart_products(data);//render cart items
                //remove cart items
                 console.log("Inside else: next remove cart call. item count before that ");
                console.log(data.item_count);
                remove_item_from_cart();
                console.log("Inside else: after remove cart call. item count now ");
                console.log(data.item_count);
                 $(".cart-count-bubble").children().eq(0).text(data.item_count);
                

              }
              document.getElementById('sidebar-cart').classList.add('open');
              document.getElementById('overlay').classList.add('open');
            });
        }
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    // this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            
            this.querySelector('.loading__spinner').classList.add('hidden');
            render_sidebar_cart();
          });


      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
